import { LANGUAGE_CODES } from "../../lib/i18n";
export var getLocaleFallbackLink = function getLocaleFallbackLink(locale) {
  return locale === LANGUAGE_CODES.english ? '/' : "/".concat(locale);
};